import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export type OuterContainerProps = {
    hide: boolean
    isMobile: boolean
    desktopHeight: number
    mobileHeight: number
}

export const OuterContainer = styled("div")<OuterContainerProps>`
    display: ${({hide, isMobile}) => (hide && isMobile ? "none" : "flex")};
    color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.textColor};
    background-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.backgroundColor};
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.borderColor};
    width: 100%;
    height: ${({mobileHeight}) => mobileHeight}rem;
    position: relative;
    z-index: 2;
    flex-direction: column;

    @media (min-width: ${breakpoints.values.md}px) {
        height: ${({desktopHeight}) => desktopHeight ?? 3.8125}rem;
    }
`
